import React from 'react';
import { FaLinkedin } from 'react-icons/fa';
import Hero from '../components/Hero';
import aboutData from '../data/about.json';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about-page">
      <Hero
        heading={aboutData.hero.heading}
        backgroundImage={aboutData.hero.backgroundImage}
        compact
      />

      {/* Introduction */}
      <section className="section">
        <div className="container">
          <div className="about-intro">
            <div className="orange-divider" />
            <h2 className="section-heading">{aboutData.intro.heading}</h2>
            {aboutData.intro.paragraphs.map((p, idx) => (
              <p key={idx} className="about-text">{p}</p>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section section-dark">
        <div className="container">
          <div className="team-header">
            <div className="orange-divider" />
            <h2 className="section-heading">{aboutData.team.heading}</h2>
          </div>
          <div className="team-grid">
            {aboutData.team.members.map((member, idx) => (
              <div key={idx} className="team-card">
                <div className="team-image-wrapper">
                  <img src={member.image} alt={member.name} loading="lazy" />
                </div>
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-title">{member.title}</p>
                  <p className="team-bio">{member.bio}</p>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="team-linkedin"
                    aria-label={`${member.name} LinkedIn`}
                  >
                    <FaLinkedin /> Connect on LinkedIn
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
